import { render, staticRenderFns } from "./properties-block-image.vue?vue&type=template&id=02f364ca&scoped=true"
import script from "./properties-block-image.vue?vue&type=script&lang=js"
export * from "./properties-block-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f364ca",
  null
  
)

export default component.exports